import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { StudyScreen } from "../../screens/understanding/StudyScreen.tsx";

/** `/study`: the study live. */
export const Route = createFileRoute("/_app/study")({
  loader: ({ context }) =>
    context.queryClient.prefetchQuery(actions.queryOptions("threads.list", { skill: "study", limit: 1 })),
  component: StudyScreen,
});
